import React from 'react';
import AggregateProto from '../aggregate-proto';

export default class AggregateSpentEstimate extends AggregateProto {

    static getValue(data) {
        let res;

        if (!data.estimate) res = null;
        else if (!data.reportedTime) res = 0;
        else res = Math.floor(100 * data.reportedTime/data.estimate);

        return res;
    }

    min() {return _.min(_(this.data).map(data=>AggregateSpentEstimate.getValue(data)).filter(value=>!_.isNil(value)).value())}
    max() {return _.max(_(this.data).map(data=>AggregateSpentEstimate.getValue(data)).filter(value=>!_.isNil(value)).value())}

    median() {
        const array = _(this.data).map(value=>AggregateSpentEstimate.getValue(value)).filter(value=>!_.isNil(value)).sortBy().value();
        if (array.length % 2 === 0) {
            // for even number elements take two values in center and divide in two
            return (array[array.length / 2] + array[(array.length / 2) - 1]) / 2;
        } else {
            // for odd number elements take value in center
            return array[(array.length - 1) / 2];
        }
    }

    sum() {
        const totalReportedTime =   _.sum(_(this.data).map(data=>data.reportedTime).filter(value=>!_.isNil(value)).value());
        const totalEstimate =       _.sum(_(this.data).map(data=>data.estimate).filter(value=>!_.isNil(value)).value());

        return AggregateSpentEstimate.getValue({
            reportedTime:   totalReportedTime,
            estimate:       totalEstimate
        })
    }
    average() {return _.mean(_(this.data).map(value=>AggregateSpentEstimate.getValue(value)).filter(value=>!_.isNil(value)).value())}
}